import { CosmeticsHarmony } from "./profileCosmeticsHarmony"

/** Пульсация ника — только всплеск и сердцебиение. */

export type ProfileNicknamePulseKey = "heartbeat" | "surge"

export type ProfileNicknamePulseMotion = "heartbeat" | "surge"

export interface ProfileNicknamePulseStyle {
  motion: ProfileNicknamePulseMotion
  duration: number
  opacityMin: number
  opacityMax: number
  scaleMax: number
  harmony: CosmeticsHarmony
}

export interface ProfileNicknamePulseDef {
  key: ProfileNicknamePulseKey
  title: string
  subtitle: string
  style: ProfileNicknamePulseStyle
}

export const PROFILE_NICKNAME_PULSES: ProfileNicknamePulseDef[] = [
  {
    key: "heartbeat",
    title: "Сердцебиение",
    subtitle: "Двойной удар",
    style: {
      motion: "heartbeat",
      duration: 1400,
      opacityMin: 0.55,
      opacityMax: 1,
      scaleMax: 1.04,
      harmony: "magma",
    },
  },
  {
    key: "surge",
    title: "Всплеск",
    subtitle: "Резкий подъём яркости",
    style: {
      motion: "surge",
      duration: 1800,
      opacityMin: 0.5,
      opacityMax: 1,
      scaleMax: 1.08,
      harmony: "storm",
    },
  },
]

export const PROFILE_NICKNAME_PULSE_BY_KEY: Record<
  ProfileNicknamePulseKey,
  ProfileNicknamePulseDef
> = PROFILE_NICKNAME_PULSES.reduce(
  (acc, item) => {
    acc[item.key] = item
    return acc
  },
  {} as Record<ProfileNicknamePulseKey, ProfileNicknamePulseDef>
)

export function isProfileNicknamePulseKey(
  value: string
): value is ProfileNicknamePulseKey {
  return value in PROFILE_NICKNAME_PULSE_BY_KEY
}

export function resolveProfileNicknamePulse(
  key: string | null | undefined
): ProfileNicknamePulseDef | null {
  if (!key || !isProfileNicknamePulseKey(key)) return null
  return PROFILE_NICKNAME_PULSE_BY_KEY[key]
}
